// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6ORsw","row":"Footer_row__fJIGV"};